import { Component, Input } from "@angular/core"
import { LexTranslateService } from "@app/core/services/lex-translate.service"
import { CardInfo, UserCardAssets } from "@app/shared/interfaces/user-card"

@Component({
  selector: "seb-wrapper-access-card",
  templateUrl: "./wrapper-access-card.component.html",
  styleUrls: ["./wrapper-access-card.component.css"],
})
export class WrapperAccessCardComponent {
  @Input() wrapperInfo: CardInfo
  @Input() userCardAssets: UserCardAssets
  welcomeMessage: string
  constructor(public lextranslate: LexTranslateService) {}

  ngOnChanges() {
    if (this.wrapperInfo) {
      this.wrapperInfo = { ...this.wrapperInfo }
      this.welcomeMessage = this.lextranslate.i18n[
        "241216ca-91d0-48ac-a78f-78a948a8e2c2"
      ].replace("[USER_NAME]", this.wrapperInfo?.userName)
    }
  }
}
